import { Col, Row, Alert, notification } from 'antd';
import * as React from 'react';
import { RouteProps } from 'react-router-dom';
import styled from 'styled-components';
import LoginForm from '../../components/UserManagement/LoginForm/LoginForm';
import NotificationUtility from 'Core/NotificationUtility';
import { Helmet } from "react-helmet";

export interface Props extends RouteProps {
  children?: React.ReactNode;
}

export interface State { }

const TallCol = styled(Col)`
  height: 100%;
  min-height: 200px;
`;

export default class LoginPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    let state: { from?: string; noPermission?: boolean } = {};

    if (this.props.location) {
      state = this.props.location.state || {};
      if (!!state.noPermission) {
        NotificationUtility.warning(
          'Session Timeout', 'User logged out due to inactivity', 0, false)
      }

    }
  }

  render() {
    return (
      <Row type="flex" align="middle">
        <Helmet><title>Login</title></Helmet>
        <TallCol xs={12} sm={12} md={6}>
          <LoginForm {...this.props} />
        </TallCol>
      </Row>
    );
  }
}
